import React from "react";
import { Navigate, useNavigate } from "react-router-dom";
import { User, Plus } from "lucide-react";
import Loading from "../../../components/Loading/Loading";
// import LogInModal from "../../../components/LogInModal/LogInModal";
import { getSession } from "../../../Slices/sessionSlice";
import { useSelector, useDispatch } from "react-redux";
import "./LandingPage.css";

const LandingPage = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  
  React.useEffect(() => {
    dispatch(getSession());
    document.title = "Redirect - Tracker";
  }, [dispatch]);

  const { sessionUser, isLoading } = useSelector((state) => state.sessionSlice);

  if (isLoading) {
    return (
      <>
        <Loading />
      </>
    );
  }

  if (
    (Boolean(sessionUser) && sessionUser.roles.includes("super-admin")) ||
    (Boolean(sessionUser) && sessionUser.roles.includes("admin"))
  ) {
    return <Navigate to="/admin/createUser" />;
  } else if (Boolean(sessionUser) && sessionUser.roles.includes("OrgAdmin")) {
    return <Navigate to="/org-admin/dashboard" />;
  } else if (Boolean(sessionUser) && sessionUser.roles.includes("Supervisor")) {
    return <Navigate to="/supervisor/dashboard" />;
  } else if (Boolean(sessionUser) && sessionUser.roles.includes("Candidate")) {
    return <Navigate to="/candidateDashboard" />;
  }

  return (
    <div className="landing-page-container">
      <div className="landing-page-panel">
        <div className="landing-page-buttons">
          <button 
            className="landing-page-button signin-button"
            onClick={() => navigate("/sign-in")}
          >
            <User className="button-icon" />
            <span>SignIn</span>
          </button>
          <button 
            className="landing-page-button signup-button"
            onClick={() => navigate("/sign-up")}
          >
            <Plus className="button-icon" />
            <span>SignUp</span>
          </button>
        </div>
      </div>
    </div>
  );
};

export default LandingPage;
